<template>
  <div id="NotesList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Notes List</div>
          <router-link v-if="canAddNotes" class="btn btn-primary pull-right" v-bind:to="{name: 'NotesCreate'}" >
            <i class="fp-add"> </i> Add
          </router-link>

        </div>
          <div class="container-fluid">
            <!--page content-->
            <div class="admin-page-content notes-list">
              <data-table-filter-config :moduleName="'notesList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
              <section class="data-table bg-white">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'notesList'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                          mode="remote"
                          ref="notesListTable"
                          @on-page-change="onPageChange"
                          @on-sort-change="onSortChange"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          @on-selected-rows-change="selectionChanged"
                          @on-select-all="onSelectAll"
                          :totalRows="totalRecords"
                          title="Notes List"
                          :columns="userColumns"
                          :rows="rows"
                          :paginate="true"

                          :paginationOptions="{
                              enabled: false,
                              position: 'both',
                              perPage: perPage,
                              perPageDropdown:dropDownPerPage,
                              dropdownAllowAll: false,
                          }"
                          :sort-options="{
                              enabled: true,
                          }"
                          :select-options="{
                              enabled: canDelete,
                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                              selectionInfoClass: 'custom-class',
                              selectionText: 'rows selected',
                              clearSelectionText: 'clear',
                              }"
                          :search-options="{
                            enabled: false,
                          }">
                          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                              <div :key="key">
                                  <div v-if="props.column.field == 'action'">
                                      <template v-if="canUpdate">
                                          <router-link title="Edit Notes" class="fp-edit" v-bind:to="{name: 'NotesEdit',params:{id:props.row.id}}"></router-link>
                                      </template>
                                  </div>
                                  <div v-else>
                                      {{props.formattedRow[props.column.field]}}
                                  </div>
                              </div>
                          </template>

                          <div slot="selected-row-actions">
                              <button v-if="canDelete" id="deleteNoteBtn" v-on:click.prevent="notesDelete" class="btn btn-danger">Delete</button>
                          </div>
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
              </section>
            </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default{

  name: 'NotesList',
  metaInfo() {
      return {title: "Notes List | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns:[],
    columns: [
      {
          label: 'Actions',
          field: 'action',
          sortable: false,
      },
      {
          label: 'Subject',
          field: 'subject',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Subject", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Description',
          field: 'description',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Description", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
            label: 'Location',
            field: 'location',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Location", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
      {
          label: 'Work Order',
          field: 'work_order',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Work Order", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Vehicle',
          field: 'vehicle',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Vehicle", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },

    ],
    rows: [],
    totalRecords: 0,
    loading:false,
    canAddNotes : false,
    canDelete :false,
  }),
  watch:{

      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'list_notes') {
                      self.cantAccessPage = true;
                  }
                  if (permissions[i].name == 'add_notes') {
                      self.canAddNotes = true;
                      self.canUpdate = true;
                  }
                  if (permissions[i].name == 'delete_notes') {
                      self.canDelete = true;
                  }
              }
          }

      }
  },
  created: function() {

  },
  mounted: function() {
      var self = this;


      self.getPermissions();
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.notesListTable.unselectAllInternal();
    },
    selectionChanged(param) {
        var self = this;
        if(param.selectedRows.length == 100) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }

    },
    loadList() {
        var self = this;
        self.loading = true;
        var data = this.$refs['notesListTable'].selectedRows;
        var selectedRows = [];

        for (var i = 0; i < data.length; i++) {
            selectedRows.push(self.$refs['notesListTable'].selectedRows[i].id)
        }

        var fields = {
            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: self.serverParams.columnFilters,
            sort: self.serverParams.sort,
            all:self.serverParams.selectedAll,
            selectedRows:selectedRows,
        };
        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/notes/list",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                  EventBus.$emit('clear-all-flags', false);
                  self.rows = data.content.row;
                  self.totalRecords = data.content.totalRecords;

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'notes-list')
            }
        });
    },
    notesDelete() {
      var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Note?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['notesListTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['notesListTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteNoteBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/note/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteNoteBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'note-delete')
                          }

                      });
                    }else{
                      console.log("no");
                    }
                });
    }

  },

};
</script>




// WEBPACK FOOTER //
// src/components/NotesList.vue